import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import track from 'react-tracking';
import { withAnalytics, safeBuildEventObj } from '@ynap/analytics';
import { performance } from '@ynap/clientside-monitoring';
import ProductSummary from '../ProductSummary/ProductSummary';
import trackEvent from './analytics';
import PropTypes from 'prop-types';
import { withOptimizely } from '@ynap/optimizely-utils';

const productSkeleton = {
    badge: { label: '' },
    designerName: '',
    href: '',
    imgSrc: {
        primary: '',
        secondary: '',
    },
    name: '',
    price: { currency: { label: '', symbol: '' }, discountPercentage: null, finalPrice: null, originalPrice: null },
    partNumber: 0,
};

@track()
export class ProductSummaryWithLink extends Component {
    @track(({ analytics, product, position, pageNumber, useIdentifier }) =>
        safeBuildEventObj(trackEvent, analytics, product, position, pageNumber, useIdentifier),
    ) // eslint-disable-line no-unused-vars
    handleClick() {
        const { optimizely } = this.props;

        if (optimizely) {
            optimizely.track('plp_to_pdp');
        }

        performance.intTiming.markSpaInteractionTime('plp_to_pdp');
    }

    render() {
        const product = this.props.loading ? productSkeleton : this.props.product;
        const productSummary = <ProductSummary {...this.props} product={product} />;
        return this.props.nativelink ? (
            <a href={product ? product.href : ''} onClick={this.props.loading ? (e) => e.preventDefault() : () => this.handleClick()}>
                {productSummary}
            </a>
        ) : (
            <Link to={product ? product.href : ''} onClick={this.props.loading ? (e) => e.preventDefault() : () => this.handleClick()}>
                {productSummary}
            </Link>
        );
    }
}

ProductSummaryWithLink.propTypes = {
    loading: PropTypes.bool,
    nativelink: PropTypes.bool,
    product: PropTypes.object.isRequired,
    useIdentifier: PropTypes.bool,
};

export default withOptimizely(withAnalytics(ProductSummaryWithLink));
